export default {
  card: {
    report: 'Report',
    verifiedPurchase: 'Verified Purchase',
    voteCount: {
      one: '{{count}} person found this helpful',
      other: '{{count}} people found this helpful',
    },
  },
  flagReview: {
    form: {
      buttonText: 'Submit',
    },
  },
  header: {
    noReviews: 'There are currently no reviews for this product',
    subtitle: '{{averageRating}} out of 5 based on {{count}} reviews',
    title: 'Product Reviews',
    writeReview: 'Write a Product Review',
  },
  reviewsRating: {
    reviews: {
      one: '{{count}} review',
      other: '{{count}} reviews',
    },
    stars: {
      one: '{{count}} star',
      other: '{{count}} stars',
    },
  },
  searchInput: {
    placeholder: 'Search product reviews',
  },
  voteButton: {
    helpful: 'Helpful',
  },
};
